var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column col-10 col-mx-auto"},[_c('div',{staticClass:"wrap"},[_c('h3',{staticClass:"entry-title"},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" "+_vm._s(_vm.message)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae90e59","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/AuthologicReturn.vue
// module id = null
// module chunks = 